import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ZendeskWebwidgetService } from 'ng-zendesk-webwidget';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'environments/environment';

declare var window;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  loading = false;
  msg: String = 'Loading...';
  loadingMsg: String = 'Loading';

  constructor(
    public zone: NgZone,
    private cdRef: ChangeDetectorRef,
    public router: Router,
    private zendeskWebwidgetService: ZendeskWebwidgetService) {
  }

  ngOnInit() {
  
  }

  ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('-- got a router event ---');
        if (event.urlAfterRedirects.indexOf('widget') === -1) {
          // dont show on the widget page
          if(environment.production == true){
            this.zendeskWebwidgetService.show();
          }
        }
      }
    });
  }

  toggleLoadingMsg(val: string) {
    this.loadingMsg = val;
    this.loading = true;
    this.cdRef.detectChanges();
  }
  dismissLoading() {
    this.loading = false;
    this.loadingMsg = 'Loading';
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts